// Shared Yahoo Finance ticker mapping and URL generation

export const YAHOO_TICKER_MAP = {
  // Commodities
  "OIL": "CL=F",
  "NATGAS": "NG=F",
  "LNG": "LNG",
  "GOLD": "GC=F",
  "SILVER": "SI=F",
  "COPPER": "HG=F",
  "CORN": "ZC=F",
  "SOY": "ZS=F",
  "WHEAT": "ZW=F",

  // Indices
  "SPX": "^GSPC",
  "NDX": "^IXIC",
  "DJI": "^DJI",
  "VIX": "^VIX",
  "DAX": "^GDAXI",
  "FTSE": "^FTSE",
  "NIKKEI": "^N225",

  // Currencies
  "USD": "DX-Y.NYB",
  "EUR": "EURUSD=X",
  "GBP": "GBPUSD=X",
  "JPY": "USDJPY=X",
  "AUD": "AUDUSD=X",
  "CNY": "USDCNY=X",

  // Rates
  "UST": "^TNX",
  "BUND": "BUNDFUTURE1!",

  // Crypto
  "BTC": "BTC-USD",
  "ETH": "ETH-USD",
};

export function getYahooUrl(symbol) {
  const clean = symbol.startsWith("$") ? symbol.slice(1) : symbol;
  const mapped = YAHOO_TICKER_MAP[clean] || clean;
  return `https://finance.yahoo.com/quote/${mapped}`;
}
